/** Textos alternativos arriba/abajo en Invoice PTC (formulario, PDF y Excel). */
export const PTC_TEXTO_MERCADERIA_MAX = 400;

export function emptyTextosMercaderiaPtcPair() {
  return { arriba: '', abajo: '' };
}

export function textosMercaderiaPtcFromCliente(cliente) {
  if (!cliente) return emptyTextosMercaderiaPtcPair();
  return {
    arriba: truncateTextoMercaderiaPtc(cliente.texto_mercaderia_ptc_arriba),
    abajo: truncateTextoMercaderiaPtc(cliente.texto_mercaderia_ptc_abajo),
  };
}

export function truncateTextoMercaderiaPtc(value) {
  return String(value ?? '').slice(0, PTC_TEXTO_MERCADERIA_MAX);
}

/** Convierte par fijo → arreglo usado por PDF / payload legacy. */
export function textosAlternativosPtcFromPair({ arriba, abajo }) {
  const items = [];
  const textoArriba = String(arriba ?? '').trim();
  const textoAbajo = String(abajo ?? '').trim();
  if (textoArriba) items.push({ texto: textoArriba, posicion: 'arriba' });
  if (textoAbajo) items.push({ texto: textoAbajo, posicion: 'abajo' });
  return items;
}

/** Normaliza datos guardados en invoice (nuevo par o arreglo histórico). */
export function pairFromInvoiceDatos(datos) {
  if (!datos || typeof datos !== 'object') return emptyTextosMercaderiaPtcPair();
  if (
    datos.textoMercaderiaPtcArriba != null
    || datos.textoMercaderiaPtcAbajo != null
  ) {
    return {
      arriba: truncateTextoMercaderiaPtc(datos.textoMercaderiaPtcArriba),
      abajo: truncateTextoMercaderiaPtc(datos.textoMercaderiaPtcAbajo),
    };
  }
  return pairFromTextosAlternativosPtc(datos.textosAlternativosPtc);
}

export function pairFromTextosAlternativosPtc(list) {
  const items = Array.isArray(list) ? list : [];
  const arribaItem = items.find((item) => item?.posicion === 'arriba');
  const abajoItem = items.find((item) => item?.posicion === 'abajo');
  const fallbackArriba = items.find((item) => item?.posicion !== 'abajo');
  return {
    arriba: truncateTextoMercaderiaPtc(arribaItem?.texto ?? fallbackArriba?.texto),
    abajo: truncateTextoMercaderiaPtc(abajoItem?.texto),
  };
}

export function textosMercaderiaPtcPayloadFromPair(pair) {
  const normalized = {
    arriba: truncateTextoMercaderiaPtc(pair?.arriba),
    abajo: truncateTextoMercaderiaPtc(pair?.abajo),
  };
  return {
    textoMercaderiaPtcArriba: normalized.arriba,
    textoMercaderiaPtcAbajo: normalized.abajo,
    textosAlternativosPtc: textosAlternativosPtcFromPair(normalized),
  };
}
